export enum SessionCode {
  Success = 'Success',
  Unauthorized = 'Unauthorized',
  Exception = 'Exception',
}
